<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar v-if="showNavbar" :docsName="docsName" />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>

              <div class="row mt-2">
                <div class="ml-4">
                  <button
                    v-if="editable"
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="
                      !invalid
                        ? speichern()
                        : $notify({
                            type: 'error',
                            title: $t('global.actionunsuccessful'),
                            text: $t('global.notallfieldsfilledcorrectly'),
                          })
                    "
                    :title="
                      invalid ? $t('global.notallfieldsfilledcorrectly') : ''
                    "
                  >
                    {{ $t("global.save") }}
                  </button>
                </div>
                <button class="btn btn-primary mr-2" @click="abbrechen">
                  <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />
                  {{ $t("global.tolist") }}
                </button>
                <div class="mr-4 ml-auto">
                  <button
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                    v-if="berechtigungen.m_lead.delete && editable"
                  >
                    <font-awesome-icon
                      class="mr-2"
                      icon="fa-duotone fa-trash"
                    />
                    <span>{{ $t("global.delete") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">
          <!-- START Daten -->
          <container-headline
            :headline="$t('global.masterdata')"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div :class="angebot.id ? 'col-xl-5' : 'col-xl-6'">
                    <single-select-firma
                      id="angebot-firma"
                      :firma="hof"
                      :editable="true"
                      :allowOpen="true"
                      :label="$t('global.farm')"
                      @confirmed="setHof"
                      :required="true"
                    />
                  </div>
                  <!-- <div :class="angebot.id ? 'col-xl-5' : 'col-xl-6'">
                    <div class="form-group">
                      <v-select
                        v-model="angebot.vermittlungsstelle"
                        label="bezeichnung"
                        :options="vermittlungsstellen"
                        :placeholder="$t('global.switchboard')"
                        :reduce="(s) => s.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.switchboard") }}</label>
                    </div>
                    <single-select-firma
                      id="angebot-firma"
                      :firma="angebot.vermittlungsstelle"
                      :editable="true"
                      :allowOpen="true"
                      :label="$t('global.switchboard')"
                      @confirmed="setVS"
                    />
                  </div> -->
                  <div class="col-xl-2" v-if="angebot.id">
                    <div class="form-group">
                      <input
                        v-model="angebot.nummer"
                        class="form-control"
                        :placeholder="$t('global.number')"
                        :readonly="true"
                      />
                      <label>{{ $t("global.number") }}</label>
                    </div>
                  </div>
                  <!-- <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="angebot.zeitbetriebsangaben"
                        label="bezeichnung"
                        :options="angebotstati"
                        placeholder="Zeitbetriebsangaben"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>Zeitbetriebsangaben</label>
                    </div>
                  </div> -->
                  <!-- <div class="col-xl-6">
                    <single-select-person
                      id="ansprechpartner"
                      :person="angebot.person"
                      :label="$t('global.contactperson')"
                      :allowOpen="true"
                      :editable="editable"
                      :required="true"
                      @confirmed="setPerson"
                    />
                  </div> -->
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="angebot.auswahlEinsatzbereich"
                        label="bezeichnung"
                        :options="einsatzbereiche"
                        :placeholder="$t('global.areasofapplication')"
                        multiple
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.areasofapplication") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <ValidationProvider
                        ref="statusProvider"
                        rules="notDisabled"
                        immediate
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="angebot.angebotstatus"
                          label="bezeichnung"
                          :options="angebotstati"
                          :placeholder="$t('global.offerstatus')"
                          :class="{ 'border-danger': errors.length }"
                        >
                          <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>

                          <template slot="option" slot-scope="option">
                            <div
                              :style="{
                                opacity: option.disabled ? 0.5 : 1,
                                cursor: option.disabled
                                  ? 'not-allowed'
                                  : 'pointer',
                              }"
                              :title="option.disabled ? option.reason : ''"
                            >
                              {{ option.bezeichnung }}
                            </div>
                          </template>
                        </v-select>
                        <label :class="{ 'text-danger': errors.length }">{{
                          $t("global.offerstatus")
                        }}</label>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-xl-3">
                    <div class="form-group">
                      <date-picker
                        date-format="dd.mm.yy"
                        :initial="angebot.von"
                        :disabled="!editable"
                        placeholder=" "
                        :show-icon="true"
                        @update="(val) => (angebot.von = val)"
                      />
                      <label>Von</label>
                    </div>
                  </div> -->
                  <div class="col-xl-4">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <label :class="{ 'text-danger': !passed }">{{
                          $t("global.From")
                        }}</label>
                        <input
                          ref="vonInput"
                          :disabled="!editable"
                          v-model="angebot.von"
                          :class="{ 'border-danger': !passed }"
                          type="date"
                          class="form-control"
                          :max="minDate"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                  <!-- <div class="col-xl-3">
                    <div class="form-group">
                      <date-picker
                        date-format="dd.mm.yy"
                        :initial="angebot.bis"
                        :disabled="!editable"
                        placeholder=" "
                        :show-icon="true"
                        @update="(val) => (angebot.bis = val)"
                      />
                      <label>Bis</label>
                    </div>
                  </div> -->
                  <div class="col-xl-4">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <label :class="{ 'text-danger': !passed }">{{
                          $t("global.till")
                        }}</label>
                        <input
                          ref="bisInput"
                          :disabled="!editable"
                          v-model="angebot.bis"
                          :class="{ 'border-danger': !passed }"
                          type="date"
                          class="form-control"
                          :min="maxDate"
                        />
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-xl-4">
                    <div class="form-group">
                      <ValidationProvider
                        :rules="{ min_value: 0, max_value: 10 }"
                        immediate
                        v-slot="{ errors }"
                      >
                        <input
                          v-model="angebot.belastungsgrad"
                          type="number"
                          class="form-control"
                          :placeholder="$t('global.degreeofload')"
                          :readonly="!editable"
                          min="0"
                          max="10"
                          :class="{ 'border-danger': errors.length }"
                        />
                        <span
                          class="minusIcon"
                          v-tooltip="'1 - 10'"
                        >
                          <font-awesome-icon icon="fa-solid fa-circle-info" />
                        </span>
                        <label :class="{ 'text-danger': errors.length }">{{
                          $t("global.fitnesspower")
                        }}</label>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <!-- <div class="col-xl-3">
                    <div class="form-group">
                      <input
                        v-model="angebot.nummer"
                        type="number"
                        class="form-control"
                        placeholder="Nummer"
                        :readonly="!editable"
                      />
                      <label>Nummer</label>
                    </div>
                  </div> -->
                  <div class="col-xl-12">
                    <div class="form-group">
                      <!--   <textarea
                        :disabled="!editable"
                        v-model="angebot.beschreibung"
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea> -->
                      <ckeditor
                        :editor="editor"
                        v-model="angebot.beschreibung"
                        :disabled="!editable"
                        @blur="angebot.beschreibung = replaceLinks(angebot.beschreibung)"
                      ></ckeditor>
                      <label>{{ $t("global.description") }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- ENDE DATEN -->
        </div>

        <!--<div class="col-xl-6 pr-4" :class="{ 'col-xl-12': !showNavbar }">

          <container-headline
            :headline="$t('global.timeoperatingdata')"
            :col="4"
          ></container-headline>
          <div class="row mb-3">
            <div class="col-xl-12 block br-t-l-0">
              <div class="eingabe-panel-kopf p-3">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <input
                        v-model="angebot.zeitbetriebsangaben.lage"
                        type="number"
                        class="form-control"
                        placeholder="Lage über Meer"
                        :readonly="!editable"
                        min="0"
                      />
                      <label>Lage über Meer</label>
                    </div>
                  </div>
                  <div class="form-check" style="padding-left: 36px">
                    <input
                      type="checkbox"
                      v-model="angebot.zeitbetriebsangaben.hat_elektrizitaet"
                      class="form-check-input"
                      :disabled="!editable"
                    />
                    <label>{{ $t("global.haselectricity") }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <ValidationProvider
                        ref="statusProvider"
                        rules="max:100"
                        immediate
                        v-slot="{ errors }"
                      >
                        <input
                          :disabled="!editable"
                          v-model="angebot.zeitbetriebsangaben.erreichbarkeit"
                          class="form-control"
                          :class="{ 'border-danger': errors.length }"
                        />
                        <label :class="{ 'text-danger': errors.length }">{{
                          $t("global.accessibility")
                        }}</label>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <ValidationProvider
                        ref="statusProvider"
                        rules="max:100"
                        immediate
                        v-slot="{ errors }"
                      >
                        <input
                          :disabled="!editable"
                          v-model="angebot.zeitbetriebsangaben.weitere_personen"
                          class="form-control"
                          :class="{ 'border-danger': errors.length }"
                        />
                        <label :class="{ 'text-danger': errors.length }">{{
                          $t("global.otherpeople")
                        }}</label>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <textarea
                        :disabled="!editable"
                        v-model="
                          angebot.zeitbetriebsangaben.weitere_personen_bemerkung
                        "
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea>
                      <label>{{ $t("global.otherpersonsremark") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <textarea
                        :disabled="!editable"
                        v-model="angebot.zeitbetriebsangaben.wohnsituation"
                        class="form-control"
                        rows="2"
                        style="resize: vertical"
                      ></textarea>
                      <label>{{ $t("global.housingsituation") }}</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="angebot.zeitbetriebsangaben.einsatzort_id"
                        label="bezeichnung"
                        :options="einsatzorte"
                        :placeholder="$t('global.placeofuse')"
                        :reduce="(el) => el.id"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.placeofuse") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="
                          angebot.zeitbetriebsangaben.sanitaere_einrichtung
                        "
                        label="bezeichnung"
                        :options="sanitaereeinrichtungen"
                        :placeholder="$t('global.sanitaryfacilities')"
                        :reduce="(el) => el.id"
                        multiple
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.sanitaryfacilities") }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div> -->

        <kalender
          v-if="id"
          :kalenderDaten="kalenderdaten"
          :von="angebot.von"
          :bis="angebot.bis"
        />

        <div class="col-xl-12" v-if="id">
          <div class="row">
            <div class="col-xl-12 p-0">
              <ul class="nav nav-tabs mt-3 fs-28">


                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 0 }"
                    :to="{
                      name: 'Angebot',
                      params: { id: id, anzeige: 0 },
                    }"
                    >{{ $t("global.periods") }}
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 1 }"
                    :to="{
                      name: 'Angebot',
                      params: { id: id, anzeige: 1 },
                    }"
                    >{{ $t("global.deployments") }}
                  </router-link>
                </li>

                <li class="nav-item">
                  <router-link
                    class="primary-headline-text nav-link"
                    :class="{ active: anzeige === 2 }"
                    :to="{
                      name: 'Angebot',
                      params: { id: id, anzeige: 2 },
                    }"
                    >{{ $t("global.surveys") }}/{{ $t("global.feedbackforms") }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="col-xl-12 p-0">
              <div class="tab-container p-3">
                <div v-if="anzeige === 2">
                  <umfrage-reiter
                    :angebot="angebot"
                    :shown="anzeige === 2"
                    :editable="editable"
                  />
                </div>
                <div v-if="anzeige === 0">
                  <zeitraeume-reiter
                    :id="id"
                    :firmaId="hof && hof.id ? hof.id : null"
                    :zeitraumliste="zeitraumliste"
                    :editable="editable"
                    :shown="anzeige === 0"
                    :minDatum="angebot.von"
                    :maxDatum="angebot.bis"
                  />
                </div>
                <div v-if="anzeige === 1">
                  <einsaetze-reiter
                    :angebotId="id"
                    :editable="editable"
                    :shown="anzeige === 1"
                    :hasZeitraum="zeitraumliste.length > 0"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <unsaved-changes-modal
        @discard="handleDiscard"
        @stay="handleStay"
        :saveFunction="invalid === true ? null : speichern"
      />
    </ValidationObserver>

    <loading-overlay v-show="loading"></loading-overlay>
    <loeschen-modal id="angebot-loeschen-modal" @confirmed="angebotloeschen" />

    <audit-log-panel
      v-if="berechtigungen.m_auditlog && berechtigungen.m_auditlog.read"
      ref="auditLogPanel"
      :angebot-id="id"
      :subtitle="angebot.nummer"
      :lookup-map="auditLookupMap"
    />
  </div>
</template>

<script>
import HeadMenu from "@/components/HeadMenu";

import ContainerHeadline from "@/components/ContainerHeadline";
import Navbar from "@/components/Navbar";
import AuditLogPanel from "@/components/global/AuditLogPanel.vue";
import AuditLookupMap from "@/mixins/AuditLookupMap";

import { apiErrorToAlert } from "@/utils/Errorhandler";

import AppApi from "@/api/AppApi";
import store from "@/store";

import page from "@/mixins/Page";
import ChangeWatcherNew from "@/mixins/ChangewatcherNew";
import UnsavedChangesModal from "@/components/Modals/UnsavedChangesModal.vue";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";

import LoeschenModal from "@/components/Modals/LoeschenModal";

import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";

import ZeitraeumeReiter from "@/newviva/components/Reiter/ZeitraeumeReiter.vue";
import EinsaetzeReiter from "@/newviva/components/Reiter/EinsaetzeReiter.vue";
import UmfrageReiter from "@/components/Reiter/Questionaireliste";
import ClassicEditor from "/custom/custom_ckeditor/build/ckeditor";

import Kalender from "@/newviva/components/Kalender.vue";
import Api from "@/api/Api";
import replaceLinks from "@/utils/Text";

export default {
  name: "Angebot",
  components: {
    HeadMenu,
    Navbar,
    ContainerHeadline,
    LoeschenModal,
    UnsavedChangesModal,
    SingleSelectFirma,
    ZeitraeumeReiter,
    EinsaetzeReiter,
    UmfrageReiter,
    Kalender,
    AuditLogPanel,
  },
  mixins: [page, ChangeWatcherNew, AuditLookupMap],
  store,
  props: {
    id: {
      type: String,
      default: null,
    },
    anzeige: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      editable: true,
      hof: {},
      kalenderdaten: null,
      angebot: {
        auswahlEinsatzbereich: [],
        zeitbetriebsangaben: {
          id: null,
          lage: null,
          erreichbarkeit: null,
          weitere_personen: null,
          weitere_personen_bemerkung: null,
          wohnsituation: null,
          einsatzort_id: null,
          sanitaere_einrichtung: null,
          hat_elektrizitaet: null,
        },
        von: "",
        bis: "",
      },
      zeitraumliste: [],
      editor: ClassicEditor,
    };
  },
  computed: {
    queryParams: function () {
      return {
        page: this.page,
        count: this.anzahlProPage,
      };
    },
    angebotstati() {
      const stati = this.$store?.state.crm.angebotstati || [];

      return stati.map((status) => {
        if (status.id === "196FD2BC74C" && this.zeitraumliste.length === 0) {
          return {
            ...status,
            disabled: true,
            reason: "Das Angebot muss einen Zeitraum enthalten.",
          };
        }
        return {
          ...status,
        };
      });
    },
    einsatzbereiche() {
      if (this.$store) return this.$store.state.crm.einsatzbereiche;
      return [];
    },
    vermittlungsstellen() {
      if (this.$store) return this.$store.state.crm.vermittlungsstellen;
      return [];
    },
    einsatzorte() {
      if (this.$store) return this.$store.state.crm.einsatzorte;
      return [];
    },
    sanitaereeinrichtungen() {
      if (this.$store) return this.$store.state.crm.sanitaereeinrichtungen;
      return [];
    },
    navbarTitel: function () {
      if (this.id) {
        return this.$t("global.offer");
      } else {
        return this.$t("global.newoffer");
      }
    },
    minDate() {
      const vonZeiten = (this.zeitraumliste || []).map(
        (z) => new Date(this.germanToIso(z.von))
      );

      if (this.angebot?.bis) {
        vonZeiten.push(new Date(this.datetimeToDate(this.angebot.bis)));
      }

      const gueltigeDaten = vonZeiten.filter((date) => !isNaN(date));
      return gueltigeDaten.length
        ? this.formatTimestamp(Math.min(...gueltigeDaten))
        : null;
    },
    maxDate() {
      const bisZeiten = (this.zeitraumliste || []).map(
        (z) => new Date(this.germanToIso(z.bis))
      );

      if (this.angebot?.von) {
        bisZeiten.push(new Date(this.datetimeToDate(this.angebot.von)));
      }

      const gueltigeDaten = bisZeiten.filter((date) => !isNaN(date));
      return gueltigeDaten.length
        ? this.formatTimestamp(Math.max(...gueltigeDaten))
        : null;
    },
  },
  watch: {
    zeitraumliste() {
      this.$nextTick(() => {
        const selectedId = this.angebot.angebotstatus?.id;

        if (selectedId === "196FD2BC74C") {
          this.angebot.angebotstatus = this.angebotstati.find(
            (s) => s.id === selectedId
          );

          this.$refs.statusProvider?.validate();
        }
      });
    },
  },
  created() {},
  mounted() {
    if (this.angebotstati?.length === 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);

    this.loadangebot();
    this.getZeitraeme();
    this.getKalenderResponse();

    this.$bus.$on("reload-zeitraeume", () => {
      console.log("reload-zeitraeume empfangen");

      this.getZeitraeme();
      this.getKalenderResponse();
    });
  },
  methods: {
    replaceLinks,
    getKalenderResponse() {
      if (this.id != null) {
        AppApi.get("/reservations-kalender/", {
          params: {
            angebotId: this.id,
          },
        }).then((response) => {
          this.kalenderdaten = response.data;
        });
      }
    },
    formatTimestamp(timestamp) {
      if (typeof timestamp === "number") {
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
      }
      return timestamp;
    },
    getZeitraeme() {
      if (this.id) {
        this.isBusy = true;

        AppApi.get("zeitraum/", {
          params: {
            angebotId: this.id,
          },
        })
          .then((response) => {
            this.zeitraumliste = response.data;
            this.ladeFehler = false;
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
            this.ladeFehler = true;
          })
          .finally(() => {
            this.isBusy = false;
          });
      }
    },

    //TODO
    loadangebot() {
      this.loading = true;

      return new Promise((resolve) => {
        if (this.id) {
          AppApi.get("angebotmaske/", { params: { id: this.id } }).then(
            (response) => {
              this.initializeangebot(response.data);
              this.loading = false;
              resolve();
            }
          );
        } else {
          this.editable = true;
          this.loading = false;
          resolve();
        }
      });
    },

    initializeangebot(angebot) {
      if (angebot) {
        angebot.von = this.germanToIso(angebot.von);
        angebot.bis = this.germanToIso(angebot.bis);

        this.hof = angebot.firma;

        // if (angebot.vermittlungsstelle) {
        //   angebot.vermittlungsstelle.name =
        //     angebot.vermittlungsstelle.bezeichnung;
        // }

        if (!angebot.zeitbetriebsangaben) {
          angebot.zeitbetriebsangaben = {
            id: null,
            lage: null,
            erreichbarkeit: null,
            weitere_personen: null,
            weitere_personen_bemerkung: null,
            wohnsituation: null,
            einsatzort_id: null,
            sanitaere_einrichtung: null,
            hat_elektrizitaet: null,
          };
        }

        this.angebot = angebot;

        this.editable = this.berechtigungen.m_lead.update !== false;

        // this.initializeChangewatcher(["lead"]);
      } else {
        console.error("angebot ist null");
      }
    },

    isoToGerman(dateString) {
      if (!dateString) {
        return null;
      }
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    },

    germanToIso(dateTimeString) {
      if (!dateTimeString) {
        return null;
      }
      const [datePart, timePart] = dateTimeString.split(" ");
      const [day, month, year] = datePart.split(".");

      return `${year}-${month}-${day}`;
    },

    speichern() {
      if (this.loading) return;
      if (!this.checkHTMLValidity()) return;
      this.loading = true;

      let json = JSON.parse(JSON.stringify(this.angebot));

      json.auswahlEinsatzbereich = json.auswahlEinsatzbereich?.map(
        (eintrag) => eintrag.id
      );
      json.angebotstatus = json.angebotstatus?.id;
      json.firma = this.hof?.id;

      json.von = this.isoToGerman(json.von);
      json.bis = this.isoToGerman(json.bis);

      json.vermittlungsstelle = json.vermittlungsstelle?.id;

      const allNull = Object.values(json.zeitbetriebsangaben).every(
        (value) => value === null
      );
      if (allNull) {
        json.zeitbetriebsangaben = null;
      }

      if (!this.id) {
        AppApi.post("angebotmaske/", json)
          .then((response) => {
            this.initializeangebot(response.data);
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.successfullysaved"),
            });

            this.$router.replace({
              name: "Angebot",
              params: { id: response.data.id, anzeige: 0 },
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        AppApi.put("angebotmaske/", json)
          .then((response) => {
            this.initializeangebot(response.data);
            this.$notify({
              type: "success",
              title: this.$t("global.actionsuccessful"),
              text: this.$t("global.successfullysaved"),
            });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    oeffneLoeschenModal() {
      this.$bus.$emit("openLoeschenModal", "angebot-loeschen-modal");
    },

    angebotloeschen() {
      if (this.id) {
        if (this.loading) return;
        this.loading = true;

        AppApi.delete("angebotmaske", { data: [this.id] })
          .then(() => {
            this.$router.push({ name: "Angebote" });
          })
          .catch((e) => {
            this.$notify(apiErrorToAlert(e));
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.abbrechen();
      }
    },

    setHof(hof) {
      this.hof = hof;
    },

    setVS(vs) {
      this.angebot.vermittlungsstelle = vs;
    },

    abbrechen() {
      this.$router.push({ name: "Angebote" });
    },

    datetimeToDate(datetime) {
      if (!datetime) return null;
      return datetime.split("T")[0].split(" ")[0];
    },

    checkHTMLValidity() {
      const vonInput = this.$refs.vonInput;
      const bisInput = this.$refs.bisInput;
      if (!vonInput.checkValidity()) {
        vonInput.reportValidity();
        return false;
      }
      if (!bisInput.checkValidity()) {
        bisInput.reportValidity();
        return false;
      }
      return true;
    },
  },
};
</script>
